import React, { useEffect, useState, startTransition } from "react";
import { IoVideocamOutline } from "react-icons/io5";
import { IoIosSearch } from "react-icons/io";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
//mui component
import {
  AppBar,
  Box,
  Stack,
  Drawer as MuiDrawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Avatar,
  Button,
  Grid,
  Toolbar,
  Typography,
  ListItemButton,
  Menu,
  Link as MuiLink,
  Modal,
  styled,
  useMediaQuery,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  useTheme as useThemee,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
//mui icons
import AppsIcon from "@mui/icons-material/Apps";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { fileManager, yourWork } from "../services/sidebarLinks";

//images
import upgradeimg from "../assetss/upgrade-btn.gif";

//react component
import Image from "./Image";

//services
import useMedia from "../hooks/useMedia";
import { useTheme } from "../hooks/useTheme";
import { useMenu } from "../hooks/useMenu";
import EditIcon from "@mui/icons-material/Edit";
import SearchBar from "./SearchBar";
import useModal from "../hooks/useModal";
import Feedback from "./Feedback";
import MicrophoneIcon from "./MicrophoneIcon";
import Setting from "./Setting";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useProjectId } from "../providers/ProjectProvider";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import ClikkleAds from "../assetss/ClikkleFavicons/Clikkle Ads favicon.png";
import ClikkleMail from "../assetss/ClikkleFavicons/Clikkle Mail-01.png";
import ClikkleCampaigns from "../assetss/ClikkleFavicons/Clikkle Campaigns favicon.png";
import ClikkleEsign from "../assetss/ClikkleFavicons/Clikkle E-sign-favicon.png";
import ClikkleFiles from "../assetss/ClikkleFavicons/Clikkle Files favicon.png";
import ClikkleHost from "../assetss/ClikkleFavicons/Clikkle Host-favicon.png";
import ClikklePitch from "../assetss/ClikkleFavicons/Clikkle Pitch-favicon.png";
import ClikkleProject from "../assetss/ClikkleFavicons/Clikkle Projects-01.png";
import ClikkleCrew from "../assetss/ClikkleFavicons/Clikkle Crew Logo.png";
import ClikkleLaunch from "../assetss/ClikkleFavicons/Clikkle Launch favicon.png";
import ProfileMenuModal from "./ProfileMenuModal";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Save } from "@mui/icons-material";
import {
  IoIosArrowBack,
  IoIosArrowForward,
  IoMdArrowDropdown,
} from "react-icons/io";
import ActionIcon from "./ActionIcon";
import { useCallback } from "react";
import axios from "axios";
import { BsBuildings, BsPlusLg } from "react-icons/bs";
import { setCookie } from "../utilities/cookies";
import axiosInstance from "../utilities/axios";
import { useChangeOrganizationId } from "../providers/OrganizationProvider";
import { PiChatTeardropText } from "react-icons/pi";
import ClikkleHr from "../assetss/ClikkleFavicons/hr favicon.png";

const drawerWidth = 260;
const appsWidth = 30;
const miniDrawerWidth = 72;

export const ProfileOrganizationDropDown = () => {
  const user = useAuthUser() || {};
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState({
    name: "Loading...",
    _id: "0",
  });
  const [organizations, setOrganization] = useState([]);
  const [isListVisible, setIsListVisible] = useState(false);
  const changeOrganizationId = useChangeOrganizationId();
  const toggleListVisibility = () => {
    setIsListVisible(!isListVisible);
  };

  const handleAddNew = () => {
    navigate("/createOrganization");
  };

  const handleEdit = () => {
    navigate("/listOrganization");
  };

  const getOrganizations = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `/api/v2/organizations/${user._id}`
      );

      let data = response.data.organizations;
      // console.log(data, "datass");

      setOrganization(data);

      let currentOrg = localStorage.getItem("org");
      if (currentOrg) {
        currentOrg = JSON.parse(currentOrg);
        setSelectedValue(currentOrg);
      } else {
        handleEdit();
      }
      // }
    } catch (e) {
      // console.log("Error List of Organization", e);
    }
  }, [setSelectedValue]);

  const handleChange = (organization) => {
    localStorage.setItem("org", JSON.stringify(organization));
    changeOrganizationId(organization._id);
    setTimeout(() => {
      startTransition(() =>
        organizations.length > 0
          ? navigate("/list-project")
          : navigate("/project-selection", { state: { organization } })
      );
    }, 500);
  };

  useEffect(() => {
    getOrganizations();
  }, []);

  function getFirstCharacter(str) {
    if (str.length === 0) {
      return "";
    }
    return str.charAt(0).toUpperCase();
  }

  return (
    <div>
      <div
        onClick={toggleListVisibility}
        className="relative flex items-center justify-center gap-2 w-full"
      >
        <div className="flex items-center gap-1">
          <BsBuildings size={15} />
          <Avatar
            sx={{ bgcolor: "#FFFFFF", width: 15, height: 15, fontSize: 12 }}
          >
            {selectedValue.logo && selectedValue.log != "" ? (
              <img
                src={selectedValue?.logo}
                width="20"
                height="20"
                sx={{ p: 0.5 }}
              />
            ) : (
              getFirstCharacter(selectedValue?.name)
            )}
          </Avatar>
        </div>
        <div className="flex items-center justify-between w-full">
          <div className="bg-transparent text-[14px] truncate ... text-gray-500">
            {selectedValue?.name ?? "N/A"}
          </div>

          <div className="flex items-center text-gray-500 ms-6">
            <IoMdArrowDropdown size={20} />
          </div>
        </div>
      </div>
      <div className="relative">
        <div
          className={` mt-2 absolute transition-opacity duration-400 w-full ${
            isListVisible ? "opacity-100 z-50" : "opacity-0 z-0"
          }`}
          style={{ fontSize: "18px" }}
        >
          {isListVisible && (
            <Box
              sx={{
                width: "100%",
                maxWidth: 360,
                backgroundColor: "background.main",
                border: 1,
                borderColor: "custom.border",
                borderBottomRightRadius: 15,
                borderBottomLeftRadius: 15,
              }}
              className="shadow-lg"
            >
              <List sx={{ pb: 0 }}>
                {organizations.map((item, index) => (
                  <ListItem
                    key={index}
                    disablePadding
                    onClick={() => handleChange(item)}
                  >
                    <ListItemButton>
                      <Avatar
                        sx={{
                          bgcolor: "#FFFFFF",
                          width: 20,
                          height: 20,
                          fontSize: 12,
                          mr: 1,
                        }}
                      >
                        {item.logo && item.log != "" ? (
                          <img
                            src={item?.logo}
                            width="20"
                            height="20"
                            sx={{ p: 0.5 }}
                          />
                        ) : (
                          getFirstCharacter(item?.name)
                        )}
                      </Avatar>

                      <ListItemText
                        primary={
                          <div className="truncate text-[14px]">
                            {item.name}
                          </div>
                        }
                      />

                      {/* <ListItemText primary= {item.name} /> */}
                      {item?._id === selectedValue?._id &&
                        item?.type == selectedValue?.type && (
                          <DoneIcon sx={{ width: 16, height: 16 }} />
                        )}
                    </ListItemButton>
                  </ListItem>
                ))}
                <Divider />
                <ListItem disablePadding>
                  <ListItemButton
                    sx={{ justifyContent: "center" }}
                    className="flex justify-center gap-1 p-1"
                    onClick={handleAddNew}
                  >
                    <AddCircleOutlineOutlinedIcon
                      sx={{ width: 15, height: 15 }}
                    />

                    {/* <ListItemText  primary="Add " /> */}
                    <p className="text-[12px]">Add</p>
                  </ListItemButton>
                  <Divider orientation="vertical" flexItem />

                  <ListItemButton
                    sx={{ justifyContent: "center" }}
                    className="flex gap-1 p-1"
                    onClick={handleEdit}
                  >
                    <EditIcon sx={{ width: 15, height: 15 }} />
                    <p className="text-[12px]">Edit</p>
                  </ListItemButton>
                </ListItem>
              </List>
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

const SidebarApps = [
  {
    name: "Ads",
    icon: "ads/logo/2023/ads.png",
    to: "https://ads.clikkle.com",
  },
  {
    name: "Projects",
    icon: "projects/logo/2023/projects.png",
    to: "https://projects.clikkle.com",
  },
  {
    name: "Launch",
    icon: "launch/logo/2023/launch.png",
    to: "https://launch.clikkle.com",
  },
  {
    name: "Pitch",
    icon: "pitch/logo/2023/pitch.png",
    to: "https://pitch.clikkle.com",
  },
  {
    name: "E-Sign",
    icon: "e-sign/logo/2023/e-sign.png",
    to: "https://esign.clikkle.com",
  },

  {
    name: "Host",
    icon: "host/logo/2023/host.png",
    to: "https://host.clikkle.com",
  },
];
const Apps = [
  {
    name: "C-Mail",
    icon: "cmail/logo/cmail.png",
    to: "https://mail.clikkle.com",
  },
  {
    name: "Ads",
    icon: "ads/logo/ads.png",
    to: "https://ads.clikkle.com",
  },
  {
    name: "Campaigns",
    icon: "campaigns/logo/campaigns.png",
    to: "https://campaigns.clikkle.com",
  },
  {
    name: "E-Sign",
    icon: "e-sign/logo/e-sign.png",
    to: "https://esign.clikkle.com",
  },
  {
    name: "Files",
    icon: "files/logo/files.png",
    to: "https://files.clikkle.com",
  },

  {
    name: "Host",
    icon: "host/logo/host.png",
    to: "https://host.clikkle.com",
  },
  {
    name: "Pitch",
    icon: "pitch/logo/pitch.png",
    to: "https://pitch.clikkle.com",
  },
  {
    name: "Projects",
    icon: "projects/logo/projects.png",
    to: "https://projects.clikkle.com",
  },
  {
    name: "Launch",
    icon: "launch/logo/launch.png",
    to: "https://launch.clikkle.com",
  },
];

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: theme.palette.background.default,
  borderRight: "none",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: theme.palette.background.default,
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  borderRight: "none",
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,

  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const handleAppClick = () => {
  window.open("https://apps.clikkle.com/", "_blank");
};

// const SideBarLinkButton = ({ menus }) => {
//   return (
//     <>
//       {menus.map((link, index) => (
//         <div key={index}>
//           <NavLink
//             to={link.to}
//             style={{ textDecoration: "none", color: "inherit" }}
//           >
//             {({ isActive }) => (
//               <>
//                 <ListItemButton
//                   selected={isActive}
//                   onClick={() => {
//                     setCollapseDrawer(false);
//                     setDrawerHover(false);
//                   }}
//                 >
//                   {/* <ListItemIcon>{link.icon}</ListItemIcon> */}
//                   <ListItemText primary={link.label} />
//                 </ListItemButton>
//                 {/* {link.subItems && (
//                   <Collapse in={isActive}>
//                     <List>
//                       {link.subItems.map((subItem, subIndex) => (
//                         <NavLink
//                           key={subIndex}
//                           to={subItem.to}
//                           style={{ textDecoration: "none", color: "inherit" }}
//                         >
//                           <ListItemButton>
//                             <ListItemText primary={subItem.label} />
//                           </ListItemButton>
//                         </NavLink>
//                       ))}
//                     </List>
//                   </Collapse>
//                 )} */}
//               </>
//             )}
//           </NavLink>
//         </div>
//       ))}
//     </>
//   );
// };

// const clikkleApps = [
//   {
//     name: "Ads",
//     url: "https://ads.clikkle.com/",
//     logo: ClikkleAds,
//   },
//   {
//     name: "Campaigns",
//     url: "https://campaigns.clikkle.com/",
//     logo: ClikkleCampaigns,
//   },
//   {
//     name: "E-Sign",
//     url: "https://esign.clikkle.com/",
//     logo: ClikkleEsign,
//   },
//   {
//     name: "Files",
//     url: "https://files.clikkle.com/",
//     logo: ClikkleFiles,
//   },
//   {
//     name: "Host",
//     url: "https://host.clikkle.com/",
//     logo: ClikkleHost,
//   },
//   {
//     name: "Launch",
//     url: "https://launch.clikkle.com/",
//     logo: ClikkleLaunch,
//   },
//   {
//     name: "C-Mail",
//     url: "https://mail.clikkle.com/",
//     logo: ClikkleMail,
//   },
//   {
//     name: "Pitch",
//     url: "https://pitch.clikkle.com/",
//     logo: ClikklePitch,
//   },
//   {
//     name: "Crew",
//     url: "https://crew.clikkle.com/",
//     logo: ClikkleCrew,
//   },
// ];
const clikkleApps = [
  {
    name: "Worksuite",
    url: "https://worksuite.clikkle.com",
    logo: "https://cdn.clikkle.com/images/worksuite/2025/clikkle%20worksuite.png",
  },
  {
    name: "Campaigns",
    url: "https://campaigns.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/campaigns/logo/2025/clikkle%20campaigns.png",
  },
  {
    name: "Chat",
    url: "https://chat.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/chat/logo/2025/clikkle%20chat.png",
  },
  {
    name: "eSign",
    url: "https://esign.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/e-sign/logo/2025/clikkle%20esign.png",
  },
  {
    name: "Files",
    url: "https://files.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/files/logo/2025/clikkle%20files.png",
  },
  {
    name: "HR",
    url: "https://hr.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/hr/logo/2025/clikkle%20hr.png",
  },
  {
    name: "Projects",
    url: "https://projects.clikkle.com/",
    logo: "https://cdn.clikkle.com/images/projects/logo/2025/clikkle%20projects.png",
  },
];

export default function Navbar(props) {
  const { children } = props;
  const user = JSON.parse(localStorage.getItem("user"));

  const projectId = useProjectId();
  const [mobileOpen, setMobileOpen] = useState(false);
  const smLayout = useMedia("(min-width: 576px)");
  const [collapseDrawer, setCollapseDrawer] = useState(true);
  const [drawerHover, setDrawerHover] = useState(false);
  const [value, setValue] = React.useState(0);
  const setSearchParams = useSearchParams()[1];
  const isAuthenticated = useIsAuthenticated();
  const [sidebarApps, setSidebarApps] = useState(clikkleApps);
  const [isOrderChanged, setIsOrderChanged] = useState(false);
  const [leftMenuOpen, setLeftMenuOpen] = useState(false);
  const [openPlusIcon, setOpenPlusIcon] = useState(false);
  const [editable, setEditable] = useState(false);
  const [ismember, setIsmember] = useState(true);
  const [recruiterOpen, setRecruiterOpen] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(true);

  const handleClick = () => {
    setClicked(true);
    setTimeout(() => setClicked(false), 300); // Reset after 300ms
  };
  const getInitials = () => {
    if (user?.firstName && user?.lastName) {
      return `${user?.firstName.charAt(0).toUpperCase()}${user?.lastName
        ?.charAt(0)
        .toUpperCase()}`;
    }
    return "?";
  };
  const [feedbackState, setFeedbackState] = useState(false);

  const openFeedback = () => setFeedbackState(true);
  const closeFeedback = () => setFeedbackState(false);

  const location = useLocation();
  // const user = useUser();

  const matches = useMediaQuery("(min-width:1024px)", { noSsr: true });

  const { toggleTheme, mode } = useTheme();
  const theme = useThemee();

  // useMenu
  const {
    anchorEl: anchorElProfile,
    openMenu: openProfileMenu,
    closeMenu: closeProfileMenu,
  } = useMenu();

  const {
    anchorEl: anchorElSettings,
    openMenu: openSettingsMenu,
    closeMenu: closeSettingsMenu,
  } = useMenu();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDrawerOpen = () => {
    setCollapseDrawer(!collapseDrawer);
  };

  useEffect(() => {
    if (isAuthenticated) {
      setSearchParams(
        (params) => {
          params.set("projectId", projectId);
          return params;
        },
        { replace: true }
      );
    }
  }, [projectId, setSearchParams, isAuthenticated]);
  const userr = useAuthUser() || {};
  useEffect(() => {
    const orgs = JSON.parse(localStorage.getItem("allOrg"));
    const selectedOrgId = localStorage.getItem("selectedOrganization");

    if (!orgs || !selectedOrgId || !userr?._id) {
      // console.log(false);
      return;
    }

    const selectedOrg = orgs.find((org) => org._id === selectedOrgId);

    if (!selectedOrg) {
      // console.log(false);
      return;
    }

    const isMember = selectedOrg.members.includes(userr._id);
    setIsmember(isMember);
    // console.log(isMember);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname, location.hash]);
  const isDarkMode = mode === "dark";

  const drawer = (
    <Box
      minHeight="100dvh"
      color="text.secondary"
      display="flex"
      flexDirection="column"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        component={Link}
        to="/"
        sx={{
          textDecoration: "none",
          color: "text.primary",
          py: 2,
          textAlign: "left",
        }}
      >
        <Image
          cdn={
            isDarkMode
              ? "/projects/logo/2025/Clikkle%20Projects%20Blue%20(%20White%20Text).png"
              : "/projects/logo/2025/Clikkle%20Project%20Blue%20(%20Black%20Text).png"
          }
          sx={{ height: "40px" }}
        />
      </Box>

      <Box
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          height: "calc(100dvh - 90px)",
          flexGrow: 1,
          "::-webkit-scrollbar": { display: "none" },
        }}
      >
        <List sx={{ px: 3, pt: 0.5, mt: 5 }}>
          {fileManager.map((link) => (
            <NavLink
              to={link.to}
              key={link.name}
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
            >
              {({ isActive }) => (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={isActive}
                    disableRipple
                    disableTouchRipple
                    variant="sidebarButton"
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "35px",
                        color: "text.secondary",
                      }}
                    >
                      {link.icon}
                    </ListItemIcon>
                    <ListItemText primary={link.name} />
                  </ListItemButton>
                </ListItem>
              )}
            </NavLink>
          ))}
        </List>
        <Divider variant="middle" />
        <Typography
          variant="body2"
          pl={3}
          mt={1.5}
          fontSize="14px"
          fontWeight={500}
        >
          Your work
        </Typography>
        <List sx={{ px: 3 }}>
          {yourWork.map((link) => (
            <NavLink
              to={link.to}
              key={link.name}
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
            >
              {({ isActive }) => (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={isActive}
                    disableRipple
                    disableTouchRipple
                    variant="sidebarButton"
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "35px",
                        color: "text.secondary",
                      }}
                    >
                      {link.icon}
                    </ListItemIcon>
                    <ListItemText primary={link.name} />
                  </ListItemButton>
                </ListItem>
              )}
            </NavLink>
          ))}
        </List>
      </Box>

      <Box>
        <Divider variant="middle" />
        <Divider
          variant="middle"
          sx={{ display: { xs: "block", sm: "none" } }}
        />
        <List sx={{ px: 1, display: { xs: "block", sm: "none" } }}>
          <ListItem
            disablePadding
            onClick={openSettingsMenu}
            sx={{
              "&:hover": {
                backgroundColor: "custom.cardHover",
                borderRadius: "8px",
              },
            }}
          >
            <ListItemButton
              disableRipple
              disableTouchRipple
              variant="sidebarButton"
            >
              <ListItemIcon
                sx={{
                  minWidth: "30px",
                  color: "text.secondary",
                }}
              >
                <SettingsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Settings"
                primaryTypographyProps={{ fontSize: 14 }}
              />
            </ListItemButton>
          </ListItem>
        </List>

        <Stack
          direction="row"
          justifyContent="center"
          my={1}
          sx={{ display: { xs: "none", sm: "flex" } }}
        >
          <MuiLink
            display="inline-flex"
            alignItems="center"
            color="text.secondary"
            sx={{ cursor: "pointer" }}
            onClick={openFeedback}
          >
            {/* <MicrophoneIcon /> */}
            <Typography variant="caption" fontWeight="bold">
              Give feedback
            </Typography>
          </MuiLink>
        </Stack>
      </Box>
    </Box>
  );
  const miniDrawer = (
    <Box
      minHeight="100dvh"
      color="text.secondary"
      display="flex"
      flexDirection="column"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        component={Link}
        mb={3}
        to="/"
        sx={{ textDecoration: "none", color: "text.primary", py: 1 }}
      >
        <Image
          cdn="https://cdn.clikkle.com/images/projects/logo/2025/clikkle%20projects.png"
          sx={{ height: "35px" }}
        />
      </Box>

      <Box
        sx={{
          overflowY: "auto",
          overflowX: "hidden",
          height: "calc(100dvh - 90px)",
          flexGrow: 1,
        }}
      >
        <List sx={{ px: 1, pb: 0 }}>
          {fileManager.map((link) => (
            <NavLink
              to={link.to}
              key={link.name}
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
            >
              {({ isActive }) => (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={isActive}
                    disableRipple
                    disableTouchRipple
                    variant="sidebarButton"
                    sx={{ height: "45px", my: "2px" }}
                  >
                    <ListItemIcon
                      sx={{
                        // minWidth: '35px',
                        color: "text.secondary",
                      }}
                    >
                      {link.icon}
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
              )}
            </NavLink>
          ))}
        </List>
        <List sx={{ px: 1, pt: 0 }}>
          {yourWork.map((link) => (
            <NavLink
              to={link.to}
              key={link.name}
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
            >
              {({ isActive }) => (
                <ListItem disablePadding>
                  <ListItemButton
                    selected={isActive}
                    disableRipple
                    disableTouchRipple
                    variant="sidebarButton"
                    sx={{ height: "45px", my: "2px" }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "35px",
                        color: "text.secondary",
                      }}
                    >
                      {link.icon}
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
              )}
            </NavLink>
          ))}
        </List>
      </Box>
    </Box>
  );

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    )
      return;
    setIsOrderChanged(true);
    const draggingJob = sidebarApps[source.index];
    sidebarApps.splice(source.index, 1);
    sidebarApps.splice(destination.index, 0, draggingJob);
    setSidebarApps([...sidebarApps]);
  };

  if (!isAuthenticated) return children;

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        px: { xs: 0.5, xm: 0 },
        height: "100dvh",
        overflow: "hidden",
      }}
    >
      <AppBar
        elevation={0}
        component={Box}
        position="sticky"
        sx={{
          width: {
            xs: "100%",
            xm:
              collapseDrawer && !drawerHover
                ? `calc(100% - ${drawerWidth}px)`
                : `calc(100% - ${miniDrawerWidth}px )`,
          },
          ml: {
            xm:
              collapseDrawer && !drawerHover
                ? `${drawerWidth}px`
                : `${miniDrawerWidth}px`,
          },
          backgroundColor: "background.default",

          borderBottom: "1px solid custom.border",
          // borderBottomColor: 'custom.border',
          color: "text.primary",
          transition: "ease-in-out 225ms, background-color 0s",
        }}
      >
        <Toolbar
          sx={{
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
            "&": {
              minHeight: "64px",
              px: 1,
            },
          }}
        >
          <Grid container alignItems="center" columnSpacing={1}>
            <Grid item>
              <IconButton
                onClick={matches ? handleDrawerOpen : handleDrawerToggle}
                edge="start"
                sx={{
                  ml: 0.2,
                  mr: 1,
                  // display: { xs: 'none', sm: 'inline-flex' },
                }}
              >
                <MenuIcon sx={{ fontSize: "30px" }} />
              </IconButton>
            </Grid>

            <Grid item xs md={5} alignItems="end">
              {isSearchOpen && <SearchBar />}
            </Grid>

            <Grid item xs display={{ xs: "none", sm: "block" }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                spacing={0.5}
                className="pr-2"
              >
                {!ismember && (
                  <Button
                    style={{
                      borderRadius: "8px",
                      marginRight: "10px",
                    }}
                  >
                    <Link
                      to={
                        "https://store.clikkle.com/subscription/projects/purchase"
                      }
                      target="_blank"
                      style={{ textDecoration: "none" }}
                    >
                      <img
                        src={upgradeimg}
                        alt="upgradeimg"
                        width={120}
                        height={35}
                      />
                    </Link>
                  </Button>
                )}
                <IconButton
                  style={{
                    width: "30px",
                    height: "30px",
                    backgroundColor: "#0080FF14",
                  }}
                  title="Create Project"
                  sx={{
                    borderRadius: 2,
                  }}
                >
                  <Link to={"/create-project"}>
                    <BsPlusLg
                      style={{ width: "20px", height: "20px" }}
                      color="#0080FF"
                    />
                  </Link>
                </IconButton>

                <IconButton
                  title="Search"
                  onClick={() => setIsSearchOpen(!isSearchOpen)}
                >
                  <IoIosSearch />
                </IconButton>
                <IconButton title="notification" onClick={handleClick}>
                  <NotificationsNoneIcon
                    style={{
                      transform: clicked ? "rotate(45deg)" : "rotate(20deg)",
                      transition: "transform 0.2s ease",
                    }}
                  />
                </IconButton>
                <Menu
                  anchorEl={anchorElSettings}
                  open={Boolean(anchorElSettings)}
                  onClose={closeSettingsMenu}
                  transformOrigin={{
                    horizontal: "right",
                    vertical: "top",
                  }}
                  anchorOrigin={{
                    horizontal: "right",
                    vertical: "bottom",
                  }}
                >
                  <Setting
                    mode={mode}
                    toggleTheme={toggleTheme}
                    closeSettingsMenu={closeSettingsMenu}
                  />
                </Menu>
                <Link to={"http://chat.clikkle.com"}>
                  <IconButton title="chat clikkle">
                    <PiChatTeardropText />
                  </IconButton>
                </Link>
                <Link to={"https://crew.clikkle.com"}>
                  <IconButton title="Video Call">
                    <IoVideocamOutline />
                  </IconButton>
                </Link>
                <IconButton>
                  <AppsIcon onClick={handleAppClick} />
                </IconButton>
                <IconButton onClick={openSettingsMenu}>
                  <SettingsIcon />
                </IconButton>
              </Stack>
            </Grid>

            <IconButton
              onClick={openProfileMenu}
              sx={{
                borderWidth: "2px",
                borderStyle: "solid",
                borderColor: "primary.main",
                p: "0px",
                ml: "7px",
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  margin: "auto",
                  width: "40px",
                  height: "40px",
                  borderRadius: user.profilePicture ? "50%" : "50%",
                  overflow: "hidden",
                  // border: user.profilePicture ? "2px solid #3B84D9" : "2px solid #3B84D9",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: user.profilePicture
                    ? "transparent"
                    : "background.view",
                  backgroundImage: user.profilePicture
                    ? `url(${user.profilePicture})`
                    : "none",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  transition: "all 0.3s ease",
                  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.6)" },
                  "&:hover .camera-icon": { opacity: 1 },
                }}
              >
                {!user.profilePicture && (
                  <Grid
                    sx={{
                      width: "110px",
                      height: "50px",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      component="div"
                      fontWeight={600}
                      sx={{
                        fontSize: "20px",
                        fontFamily: "sans-serif",
                        marginLeft: "-12px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        margin: "auto",
                      }}
                    >
                      {getInitials()}
                    </Typography>
                  </Grid>
                )}
              </Box>
            </IconButton>

            <ProfileMenuModal
              anchorElProfile={anchorElProfile}
              closeProfileMenu={closeProfileMenu}
              setRecruiterOpen={setRecruiterOpen}
            />
          </Grid>
        </Toolbar>

        <Box
          sx={{
            width: appsWidth,
            display: { xs: "none", xm: "block" },
            backgroundColor: "background.default",
            zIndex: "1200",
            position: "absolute",
            right: 0,
            top: 65,
            height: "80vh",
          }}
          className="mt-1"
        >
          <Stack
            direction="column"
            justifyContent={leftMenuOpen ? "start" : "end"}
            alignItems="center"
            spacing={1}
            px={0.8}
            height={"100%"}
            overflowY="auto"
          >
            {leftMenuOpen && (
              <>
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="apps" isDropDisabled={!editable}>
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}>
                        {sidebarApps.map((app, i) => (
                          <Draggable
                            key={i}
                            draggableId={app.name}
                            index={i}
                            isDragDisabled={!editable}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <ActionIcon
                                  title={editable ? "" : app.name}
                                  href={app.url}
                                  src={app.logo}
                                  key={app.order}
                                  sx={{ mt: 0.8, width: "35px" }}
                                  imageSx={{
                                    filter:
                                      editable &&
                                      `drop-shadow(0px 2px 2px ${theme.palette.primary.main})`,
                                  }}
                                />
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                <Divider variant="middle" sx={{ my: 2, width: "80%" }} />
                {editable ? (
                  <ActionIcon
                    title="Save"
                    icon={<DoneIcon fontSize="small" />}
                    onClick={() => {
                      setEditable(false);
                      // if (isOrderChanged) saveOrder();
                    }}
                  />
                ) : (
                  <ActionIcon
                    title="Edit"
                    icon={<EditIcon className="w-5" />}
                    onClick={() => setEditable(true)}
                  />
                )}
              </>
            )}
            <Box className="h-[80vh] flex justify-end items-end">
              {leftMenuOpen ? (
                <div
                  style={{
                    padding: "7px",
                    borderTop: "1px solid #1e2734",
                    borderLeft: "1px solid #1e2734",
                    borderBottom: "1px solid #1e2734",
                    cursor: "pointer",
                    borderTopLeftRadius: "15px",
                    borderBottomLeftRadius: "15px",
                    marginLeft: "15px",
                  }}
                  onClick={() => setLeftMenuOpen(!leftMenuOpen)}
                  className="h-fit w-fit"
                >
                  <IoIosArrowForward />
                </div>
              ) : (
                <div
                  style={{
                    padding: "7px",
                    borderTop: "1px solid #1e2734",
                    borderLeft: "1px solid #1e2734",
                    borderBottom: "1px solid #1e2734",
                    marginLeft: "10px",
                    cursor: "pointer",
                    borderTopLeftRadius: "15px",
                    borderBottomLeftRadius: "15px",
                  }}
                  className="h-fit w-fit"
                  onClick={() => setLeftMenuOpen(!leftMenuOpen)}
                >
                  <IoIosArrowBack />
                </div>
              )}
            </Box>
          </Stack>
        </Box>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: { xm: drawerWidth },
          flexShrink: { sm: 0 },
          bgcolor: "custom.menu",
        }}
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <MuiDrawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", xm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              bgcolor: "custom.menu",
            },
          }}
        >
          {drawer}
        </MuiDrawer>
        <Drawer
          variant="permanent"
          open={collapseDrawer}
          hover={`${drawerHover}`}
          onMouseOver={() => {
            if (!collapseDrawer) {
              setCollapseDrawer(true);
              setDrawerHover(true);
            }
          }}
          onMouseLeave={() => {
            if (drawerHover) {
              setCollapseDrawer(false);
              setDrawerHover(false);
            }
          }}
          sx={{
            display: { xs: "none", xm: "block" },
            p: 0,
            "& .MuiDrawer-paper": {
              boxShadow: drawerHover
                ? "rgba(149, 157, 165, 0.2) 0px 8px 24px"
                : "none",
            },
          }}
        >
          {collapseDrawer ? drawer : miniDrawer}
        </Drawer>
      </Box>
      <Paper
        sx={{
          width: "100%",
          display: { sm: "none", xs: "block" },
          flexBasis: "100%",
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
        }}
      >
        <BottomNavigation
          className="bottom-nav"
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          {fileManager.map((menu, i) => (
            <BottomNavigationAction
              component={Link}
              label={menu.name}
              to={menu.to}
              icon={menu.icon}
              key={i}
            />
          ))}
          {yourWork.map((menu) => (
            <BottomNavigationAction
              component={Link}
              label={menu.name}
              to={menu.to}
              icon={menu.icon}
              key={menu.to}
            />
          ))}
        </BottomNavigation>
      </Paper>

      <Box
        component="main"
        id="main"
        sx={{
          width: {
            xs: "100%",
            xm:
              collapseDrawer && !drawerHover
                ? `calc(100% - ${drawerWidth + appsWidth}px)`
                : `calc(100% - ${appsWidth + miniDrawerWidth}px )`,
          },
          ml: {
            xm:
              collapseDrawer && !drawerHover
                ? `${drawerWidth}px`
                : `${miniDrawerWidth}px`,
          },
          mt: 1,

          height: { xs: "calc(100dvh - 90px)" },
          backgroundColor: "background.main",
          borderRadius: "12px",
        }}
      >
        {children}
      </Box>

      <Modal
        open={feedbackState}
        onClose={closeFeedback}
        sx={{
          overflowY: "scroll",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <Feedback open={feedbackState} onClose={closeFeedback} />
      </Modal>
    </Box>
  );
}
